module.exports = __webpack_public_path__ + "img/B-1.d15e0043.png";